import { useRouteError, isRouteErrorResponse, Link } from 'react-router';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import MuiLink from '@mui/material/Link';

export default function ErrorBoundaryPage() {
    const error = useRouteError();

    if (isRouteErrorResponse(error)) {
        return (
            <Box
                sx={{
                    p: 4,
                    textAlign: 'center',
                    height: '100vh',
                    bgcolor: 'background.default',
                    color: 'text.primary',
                }}
            >
                <Typography variant="h4">
                    {error.status} — {error.statusText}
                </Typography>
                <Typography>{typeof error.data === 'string' ? error.data : ''}</Typography>
                <MuiLink component={Link} to="/" color="primary">
                    Go to Projects
                </MuiLink>
            </Box>
        );
    }

    return (
        <Box
            sx={{
                p: 4,
                textAlign: 'center',
                height: '100vh',
                bgcolor: 'background.default',
                color: 'text.primary',
            }}
        >
            <Typography variant="h4">Something went wrong</Typography>
            <Typography>{error instanceof Error ? error.message : 'An unexpected error occurred.'}</Typography>
            <Button
                variant="outlined"
                onClick={() => {
                    location.reload();
                }}
                sx={{ mt: 2 }}
            >
                Reload
            </Button>
        </Box>
    );
}
